import React from 'react';
import { Button } from "@/components/ui/button";
import { createPageUrl } from "@/utils";
import { ClipboardList, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

export default function Dashboard() {
  // Set page title
  React.useEffect(() => {
    document.title = "Intake form by Efficio";
  }, []);

  return (
    <>
      <PageHeader />
      <div className="container mx-auto py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Intake Form</h1>
          
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <ClipboardList className="h-16 w-16 mx-auto text-blue-600 mb-4" />
            
            <h2 className="text-2xl font-semibold mb-4">Welcome to the Dispute Intake System</h2>
            
            <p className="text-gray-600 mb-8">
              Use this system to submit disputes on behalf of cardholders. You can search for cardholders,
              select disputed transactions, and collect all required information for dispute processing.
            </p>
            
            <Link to={createPageUrl("DisputeIntake")}>
              <Button className="bg-blue-600 hover:bg-blue-700 min-w-[200px]">
                Start New Dispute
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}